module.exports = __webpack_public_path__ + "static/img/firefox.d648377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/firefox.png
// module id = KGKT
// module chunks = 29